import React from "react";
import { NakiRadioPremiumBadgeTemplate } from "themes/application/payment/components";

function NakiRadioPremiumBadge(props) {
    return <NakiRadioPremiumBadgeTemplate {...props} />;
}

export default NakiRadioPremiumBadge;
